import React from 'react';

import pluckrP from '@/assets/images/pluckr-p.png';
import pluckrPDark from '@/assets/images/pluckr-p-dark.png';

const HeroSection = ({ testId = 'hero-section' }) => {
  return (
    <section
      className="bg-white dark:bg-[#050506] py-10 md:py-16 lg:py-24 xl:py-32"
      data-testid={testId}
    >
      <div className="max-w-[1400px] mx-auto px-4 md:px-6 lg:px-20">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 md:gap-10 lg:gap-16 items-center">
          {/* Left Column - Text */}
          <div className="text-center lg:text-left order-2 lg:order-1">
            <h1 
              className="text-[32px] sm:text-4xl md:text-5xl lg:text-6xl xl:text-[72px] font-bold text-[#1a1a1a] dark:text-white leading-[1.15] md:leading-[1.12] tracking-tight"
              style={{ fontFamily: "'Martel Sans', sans-serif" }}
            >
              The missing{' '}
              <span className="text-[#9be38f]">
                production layer
              </span>
              <br />
              for AI builders.
            </h1>

            <p 
              className="mt-6 md:mt-8 text-base sm:text-lg md:text-xl lg:text-2xl text-[#5a5a5a] dark:text-[#e0e0e0] leading-relaxed"
              style={{ fontFamily: "'Martel Sans', sans-serif" }}
            >
              
            </p>
          </div>

          {/* Right Column - Image */}
          <div className="flex justify-center lg:justify-end order-1 lg:order-2">
            <div className="w-full max-w-[280px] sm:max-w-[320px] md:max-w-[400px] lg:max-w-[480px]">
              <img
                src={pluckrP}
                alt="Pluckr"
                className="w-full h-auto object-contain dark:hidden"
                loading="eager"
              />
              <img
                src={pluckrPDark}
                alt="Pluckr"
                className="hidden w-full h-auto object-contain dark:block"
                loading="eager"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
